import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    OutlinedInput,
    Radio,
    RadioGroup,
} from "@mui/material";

const FormReviewDialog = ({ onSave, onClose, open, type }) => {
    const [action, setAction] = useState(null);
    const [notes, setNotes] = useState("");

    const onSubmit = () => {
        const params = { action };
        if (!!notes && action === "reject") {
            params.notes = notes;
        }
        onSave(params);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
            <DialogTitle>{`Review ${type}`}</DialogTitle>
            <DialogContent dividers={false}>
                <DialogContentText>{`Please confirm your acceptance of these ${type}`}</DialogContentText>

                <FormControl component="div" fullWidth={true} margin={"normal"}>
                    <RadioGroup
                        row
                        name="radio-approve"
                        onChange={({ target }) => setAction(target.value)}
                    >
                        <FormControlLabel
                            value="approve"
                            control={<Radio />}
                            label="Approve"
                        />
                        <FormControlLabel
                            value="reject"
                            control={<Radio />}
                            label="Reject"
                        />
                    </RadioGroup>
                </FormControl>
                {action === "reject" && (
                    <FormControl
                        component="div"
                        fullWidth={true}
                        margin={"normal"}
                    >
                        <OutlinedInput
                            value={notes}
                            onChange={({ target }) => setNotes(target.value)}
                            placeholder="Comments *"
                            multiline
                            rows={2}
                        />
                        <FormHelperText>Add comments here</FormHelperText>
                    </FormControl>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={onSubmit}
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    disabled={action === null || (action === 'reject' && !notes)}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FormReviewDialog;
